import React from "react";

export default function NumberWithUnit({ label, value, unit }) {
  const isNumeric = typeof value === "number" && Number.isFinite(value);
  const displayValue = isNumeric ? value.toFixed(2) : value;

  return (
    <div className="metric-row">
      <span className="metric-label">{label}</span>
      <span className="metric-value">{displayValue}</span>
      {unit ? <span className="metric-unit">{unit}</span> : null}
    </div>
  );
}
